import { NgModule } from '@angular/core';
import { AbcAutoCompleteInputComponent } from './abcAutoCompleteInput.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { HighlightPipe } from './highlightSearch.pipe';
import { MatInputModule } from '@angular/material/input';
import { AbcAutoCompleteWithCoordsComponent } from '../abcAutoCompleteInputWithCoords/abcAutoCompleteInputWithCoords.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatIconModule,
    MatInputModule,
  ],
  declarations: [AbcAutoCompleteInputComponent, AbcAutoCompleteWithCoordsComponent, HighlightPipe],
  exports: [AbcAutoCompleteInputComponent, AbcAutoCompleteWithCoordsComponent, MatAutocompleteModule, MatInputModule],
})
export class AbcAutoCompleteInputModule {
  constructor() {}
}
